function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { MapBackend, MapLayer } from "../map";
import update from "immutability-helper";
import { assembleColumnSummary } from "../../handlers/columns";
export * from "./types";
var classColors = {
  sedimentary: "#FF8C00",
  metamorphic: "#8B4513",
  igneous: "#9F1D0F",
  marine: "#047BFF",
  "non-marine": "#A67A45",
  "precious commodity": "#FDFDFC",
  material: "#777777",
  water: "#00CCFF",
  energy: "#333333"
};
var defaultState = {
  initialLoadComplete: false,
  contextPanelOpen: false,
  allColumns: null,
  allColumnsCancelToken: null,
  menuOpen: false,
  aboutOpen: false,
  infoDrawerOpen: false,
  infoDrawerExpanded: false,
  infoMarkerPosition: null,
  infoMarkerFocus: null,
  elevationChartOpen: false,
  mapBackend: MapBackend.MAPBOX,
  mapLayers: new Set([MapLayer.BEDROCK, MapLayer.LINES, MapLayer.LABELS]),
  mapSettings: {
    highResolutionTerrain: true
  },
  // Events and tokens for xhr
  isFetching: false,
  fetchingMapInfo: false,
  mapInfoCancelToken: null,
  fetchingColumnInfo: false,
  columnInfoCancelToken: null,
  fetchingXdd: false,
  xddCancelToken: null,
  xddInfo: [],
  isSearching: false,
  inputFocus: false,
  term: "",
  searchCancelToken: null,
  fetchingElevation: false,
  elevationCancelToken: null,
  fetchingPbdb: false,
  mapInfo: [],
  columnInfo: null,
  searchResults: null,
  elevationData: [],
  elevationMarkerLocation: [],
  pbdbData: [],
  mapIsLoading: false,
  mapCenter: {
    type: null
  },
  mapUse3D: false,
  filtersOpen: false,
  filters: [],
  filteredColumns: {},
  data: [],
  showExperimentsPanel: false,
  mapPosition: {
    camera: {
      lng: 23,
      lat: 16,
      altitude: 300000
    }
  }
};
export function coreReducer() {
  var _action$open, _action$menuOpen;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case "set-map-backend":
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          mapBackend: action.backend
        });
      }

    case "map-loading":
      if (state.mapIsLoading) return state;
      return _objectSpread(_objectSpread({}, state), {}, {
        mapIsLoading: true
      });

    case "map-idle":
      if (!state.mapIsLoading) return state;
      return _objectSpread(_objectSpread({}, state), {}, {
        mapIsLoading: false
      });

    case "map-layers-changed":
      var columnInfo = state.columnInfo;
      var pbdbData = state.pbdbData;
      if (!action.mapLayers.has(MapLayer.COLUMNS)) columnInfo = null;
      if (!action.mapLayers.has(MapLayer.FOSSILS)) pbdbData = [];
      return _objectSpread(_objectSpread({}, state), {}, {
        columnInfo: columnInfo,
        pbdbData: pbdbData
      });

    case "toggle-menu":
      var shouldOpen = state.inputFocus || !state.menuOpen;
      return _objectSpread(_objectSpread({}, state), {}, {
        contextPanelOpen: shouldOpen,
        menuOpen: shouldOpen,
        isSearching: false,
        inputFocus: false
      });

    case "stop-searching":
    case "context-outside-click":
      if (state.inputFocus) {
        return _objectSpread(_objectSpread({}, state), {}, {
          inputFocus: false,
          contextPanelOpen: false,
          menuOpen: false,
          term: ""
        });
      }

      return state;

    case "toggle-about":
      return _objectSpread(_objectSpread({}, state), {}, {
        aboutOpen: !state.aboutOpen
      });

    case "toggle-experiments-panel":
      return _objectSpread(_objectSpread({}, state), {}, {
        showExperimentsPanel: (_action$open = action.open) !== null && _action$open !== void 0 ? _action$open : !state.showExperimentsPanel
      });

    case "close-infodrawer":
      return _objectSpread(_objectSpread({}, state), {}, {
        infoDrawerOpen: false,
        infoMarkerPosition: null,
        columnInfo: {}
      });

    case "expand-infodrawer":
      return _objectSpread(_objectSpread({}, state), {}, {
        infoDrawerExpanded: !state.infoDrawerExpanded
      });

    case "toggle-filters":
      // rework this to open menu panel
      return _objectSpread(_objectSpread({}, state), {}, {
        filtersOpen: !state.filtersOpen
      });

    case "add-filter":
      // action.filter.type and action.filter.id go to the URI
      // handle search resetting
      return _objectSpread(_objectSpread({}, coreReducer(state, {
        type: "stop-searching"
      })), {}, {
        filters: buildFilters(state.filters, [action.filter])
      });

    case "set-filters":
      /* Set multiple filters at once, usually on app load. */
      return _objectSpread(_objectSpread({}, state), {}, {
        filters: buildFilters(state.filters, action.filters)
      });

    case "remove-filter":
      return _objectSpread(_objectSpread({}, state), {}, {
        filters: state.filters.filter(function (d) {
          if (d.name != action.filter.name) return d;
        })
      });

    case "clear-filters":
      return _objectSpread(_objectSpread({}, state), {}, {
        filters: []
      });

    case "start-map-query":
      // if (state.inputFocus) {
      //   return { ...state, inputFocus: false };
      // }
      if (state.mapInfoCancelToken) {
        state.mapInfoCancelToken.cancel();
      }

      return _objectSpread(_objectSpread({}, state), {}, {
        infoMarkerPosition: {
          lng: action.lng,
          lat: action.lat
        },
        infoMarkerFocus: null,
        fetchingMapInfo: true,
        infoDrawerOpen: true,
        mapInfoCancelToken: action.cancelToken
      });

    case "recenter-query-marker":
      var pos = state.infoMarkerPosition;
      if (pos == null) return state;
      return _objectSpread(_objectSpread({}, state), {}, {
        infoMarkerPosition: _objectSpread({}, pos),
        infoMarkerFocus: null
      });

    case "received-map-query":
      if (action.data && action.data.mapData) {
        action.data.mapData = action.data.mapData.map(function (source) {
          if (source.macrostrat) {
            if (source.macrostrat.liths) {
              var types = {};
              source.macrostrat.liths.forEach(function (lith) {
                if (!types[lith.lith_type]) {
                  types[lith.lith_type] = {
                    name: lith.lith_type,
                    color: classColors[lith.lith_class]
                  };
                }
              });
              source.macrostrat.lith_types = Object.keys(types).map(function (l) {
                return types[l];
              });
            }

            if (source.macrostrat.environs) {
              var _types = {};
              source.macrostrat.environs.forEach(function (environ) {
                if (!_types[environ.environ_type]) {
                  _types[environ.environ_type] = {
                    name: environ.environ_type,
                    color: classColors[environ.environ_class]
                  };
                }
              });
              source.macrostrat.environ_types = Object.keys(_types).map(function (l) {
                return _types[l];
              });
            }

            if (source.macrostrat.econs) {
              var _types2 = {};
              source.macrostrat.econs.forEach(function (econ) {
                if (!_types2[econ.econ_type]) {
                  _types2[econ.econ_type] = {
                    name: econ.econ_type,
                    color: classColors[econ.econ_class]
                  };
                }
              });
              source.macrostrat.econ_types = Object.keys(_types2).map(function (l) {
                return _types2[l];
              });
            }
          }

          return source;
        });
      }

      return _objectSpread(_objectSpread({}, state), {}, {
        fetchingMapInfo: false,
        mapInfo: action.data,
        infoDrawerOpen: true
      });

    case "start-column-query":
      if (state.columnInfoCancelToken) {
        state.columnInfoCancelToken.cancel();
      }

      return _objectSpread(_objectSpread({}, state), {}, {
        fetchingColumnInfo: true,
        columnInfo: null,
        columnInfoCancelToken: action.cancelToken
      });

    case "set-all-columns":
      return _objectSpread(_objectSpread({}, state), {}, {
        allColumns: action.columns
      });

    case "received-column-query":
      // summarize units
      if (state.allColumns == null || state.allColumns.length == 0) {
        return state;
      }

      return _objectSpread(_objectSpread({}, state), {}, {
        fetchingColumnInfo: false,
        columnInfo: assembleColumnSummary(action.column, action.data)
      });

    case "toggle-map-layer":
      var op = state.mapLayers.has(action.layer) ? "$remove" : "$add";

      var mapLayers = _defineProperty({}, op, [action.layer]);

      return update(state, {
        mapLayers: mapLayers
      });

    case "toggle-map-3d":
      return _objectSpread(_objectSpread({}, state), {}, {
        mapUse3D: !state.mapUse3D
      });

    case "toggle-elevation-chart":
      return _objectSpread(_objectSpread({}, state), {}, {
        elevationChartOpen: !state.elevationChartOpen,
        elevationData: [],
        elevationMarkerLocation: []
      });

    case "set-input-focus":
      return _objectSpread(_objectSpread({}, state), {}, {
        term: action.inputFocus ? state.term : "",
        inputFocus: action.inputFocus,
        menuOpen: (_action$menuOpen = action.menuOpen) !== null && _action$menuOpen !== void 0 ? _action$menuOpen : state.menuOpen,
        contextPanelOpen: action.inputFocus || action.menuOpen
      });

    case "set-search-term":
      return _objectSpread(_objectSpread({}, state), {}, {
        term: action.term
      });
    // Handle searching

    case "start-search-query":
      // When a search is requested, cancel any pending requests first
      if (state.searchCancelToken) {
        state.searchCancelToken.cancel();
      }

      return _objectSpread(_objectSpread({}, state), {}, {
        isSearching: true,
        searchCancelToken: action.cancelToken
      });

    case "received-search-query":
      return _objectSpread(_objectSpread({}, state), {}, {
        isSearching: false,
        searchResults: action.data,
        searchCancelToken: null
      });

    case "start-xdd-query":
      // When a search is requested, cancel any pending requests first
      if (state.xddCancelToken) {
        state.xddCancelToken.cancel();
      }

      return _objectSpread(_objectSpread({}, state), {}, {
        fetchingXdd: true,
        xddCancelToken: action.cancelToken
      });

    case "received-xdd-query":
      var parsed = {
        journals: []
      };
      var articles = {};
      console.log(action.data);

      for (var i = 0; i < action.data.length; i++) {
        var found = false;

        if (articles[action.data[i].docid]) {
          continue;
        } else {
          articles[action.data[i].docid] = true;
        }

        for (var j = 0; j < parsed.journals.length; j++) {
          if (parsed.journals[j].name === action.data[i].journal) {
            parsed.journals[j].articles.push(action.data[i]);
            found = true;
          }
        }

        if (!found) {
          parsed.journals.push({
            name: action.data[i].journal,
            source: action.data[i].publisher,
            articles: [action.data[i]]
          });
        }
      }

      return _objectSpread(_objectSpread({}, state), {}, {
        fetchingXdd: false,
        xddInfo: action.data,
        xddCancelToken: null
      });
    // Handle elevation

    case "start-elevation-query":
      // When a search is requested, cancel any pending requests first
      if (state.elevationCancelToken) {
        state.elevationCancelToken.cancel();
      }

      return _objectSpread(_objectSpread({}, state), {}, {
        fetchingElevation: true,
        elevationCancelToken: action.cancelToken
      });

    case "received-elevation-query":
      return _objectSpread(_objectSpread({}, state), {}, {
        fetchingElevation: false,
        elevationData: action.data,
        elevationCancelToken: null
      });

    case "update-elevation-marker":
      return _objectSpread(_objectSpread({}, state), {}, {
        elevationMarkerLocation: [action.lng, action.lat]
      });
    // Handle PBDB

    case "start-pbdb-query":
      return _objectSpread(_objectSpread({}, state), {}, {
        fetchingPbdb: true
      });

    case "received-pbdb-query":
      return _objectSpread(_objectSpread({}, state), {}, {
        fetchingPbdb: false,
        pbdbData: action.data,
        infoDrawerOpen: true
      });

    case "reset-pbdb":
      return _objectSpread(_objectSpread({}, state), {}, {
        pbdbData: []
      });

    case "go-to-place":
      return _objectSpread(_objectSpread({}, coreReducer(state, {
        type: "set-input-focus",
        inputFocus: false
      })), {}, {
        mapCenter: {
          type: "place",
          place: action.place
        }
      });

    case "update-column-filters":
      return _objectSpread(_objectSpread({}, state), {}, {
        filteredColumns: action.columns
      });

    case "request-data":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetching: true
      });

    case "recieve-data":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetching: false,
        data: action.data
      });

    case "map-moved":
      return _objectSpread(_objectSpread({}, state), action.data);

    case "toggle-high-resolution-terrain":
      return update(state, {
        mapSettings: {
          $toggle: ["highResolutionTerrain"]
        }
      });

    default:
      return state;
  }
}

function isTheSame(f, newFilter) {
  return f.name === newFilter.name && f.type === newFilter.type && f.id === newFilter.id;
}

function isOverlappingType(f1, f2) {
  /* Check if the filter is the same type or including all_ */
  var t1 = f1.type.startsWith("all_") ? f1.type.replace("all_", "") : f1.type;
  var t2 = f2.type.startsWith("all_") ? f2.type.replace("all_", "") : f2.type;
  return f1.name === f2.name && t1 === t2 && f1.id === f2.id;
}

export function buildFilters(filters, newFilters) {
  // Remove any existing filters of the same type
  var remainingFilters = filters.filter(function (f) {
    return !newFilters.some(function (nf) {
      return isOverlappingType(f, nf);
    });
  });
  return [].concat(_toConsumableArray(remainingFilters), _toConsumableArray(newFilters));
}